<template>
    <div ref="icon">
        <span 
            v-if="isFavorite"
            v-cloak
            class="date"
            v-text="dateAdded"
        />
        <span 
            v-else
            v-cloak
            class="removed"
            v-text="removeText"
        />
        <span>
            <a
                v-cloak
                v-if="isFavorite !== null"
                href="#"
                @click.prevent="toggle"
            >
                <i class="fa" :class="isFavorite ? 'fa-trash' : 'fa-undo'"></i>
            </a>
        </span>
    </div>
</template>
<script>
import axios from 'axios';
import FavoriteButton from './FavoriteButton';

export default {
    props: {
        id: { required: true },
        dateAdded: { required: true },
        removeText: { required: true },
    },
    mixins: [ FavoriteButton ],
    methods: {
        toggle() {
            this.favorite()
            .then(() => {
                const parent = this.$refs.icon.closest('.favoriteProduct');

                if (parent) {
                    if (this.isFavorite) {
                        parent.classList.remove('-removed');
                    } else {
                        parent.classList.add('-removed');
                    }
                }
            });
        },
    },
}
</script>
